

// // import { useEffect, useRef, useState } from 'react';
// // import { gsap } from 'gsap';
// // import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // import { fetchSkillGroups, fetchSkillsMeta } from './data';
// // import { Label } from './utils';

// // gsap.registerPlugin(ScrollTrigger);

// // function easeInOutCubic(t) {
// //   return t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2;
// // }

// // const DEFAULT_DESKTOP_VW = 22;
// // const DEFAULT_MOBILE_VW  = 48;

// // export default function Skills({ loaded, isMobile }) {
// //   const [skillGroups, setSkillGroups] = useState([]);
// //   const [imgUrl,      setImgUrl]      = useState('');

// //   // Width values live in refs — NOT state.
// //   // The onUpdate closure reads them directly, so changing them
// //   // never needs to recreate the ScrollTrigger.
// //   const desktopVwRef = useRef(DEFAULT_DESKTOP_VW);
// //   const mobileVwRef  = useRef(DEFAULT_MOBILE_VW);

// //   const wrapperRef   = useRef(null);
// //   const sectionRef   = useRef(null);
// //   const imgRef       = useRef(null);

// //   // ── Data fetch ───────────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     fetchSkillGroups().then(setSkillGroups).catch(console.error);

// //     fetchSkillsMeta()
// //       .then(m => {
// //         if (m.floatingImage)              setImgUrl(m.floatingImage);
// //         if (m.desktopWidthVw != null)     desktopVwRef.current = Number(m.desktopWidthVw);
// //         if (m.mobileWidthVw  != null)     mobileVwRef.current  = Number(m.mobileWidthVw);
// //       })
// //       .catch(console.error);
// //   }, []);

// //   // ── GSAP: pin only — created once when loaded ─────────────────────────────
// //   // This ScrollTrigger must never be killed/recreated, otherwise the pinned
// //   // section loses its layout position mid-scroll.
// //   useEffect(() => {
// //     if (!loaded) return;

// //     const pin = ScrollTrigger.create({
// //       trigger:    wrapperRef.current,
// //       start:      'top top',
// //       end:        'bottom bottom',
// //       pin:        sectionRef.current,
// //       pinSpacing: false,
// //     });

// //     return () => pin.kill();
// //   }, [loaded]);

// //   // ── GSAP: animation — created once when loaded AND img is in the DOM ──────
// //   // onUpdate reads imgW fresh on every scroll tick via the refs,
// //   // so width changes from Firestore are picked up without recreating anything.
// //   useEffect(() => {
// //     if (!loaded)          return;
// //     if (!imgRef.current)  return; // img not mounted yet

// //     const getImgW = () => {
// //       const vw = (v) => (v / 100) * window.innerWidth;
// //       return isMobile ? vw(mobileVwRef.current) : vw(desktopVwRef.current);
// //     };

// //     // Set initial position with whatever width we have right now
// //     const imgW   = getImgW();
// //     const startX =  window.innerWidth  + imgW * 0.1;
// //     const startY = -(imgW * 1.3);
// //     const endX   = -(imgW * 1.1);
// //     const endY   =  window.innerHeight + imgW * 0.1;

// //     gsap.set(imgRef.current, {
// //       x:        startX,
// //       y:        startY,
// //       rotation: 12,
// //       opacity:  0,
// //       width:    imgW,
// //     });

// //     const anim = ScrollTrigger.create({
// //       trigger: wrapperRef.current,
// //       start:   'top top',
// //       end:     'bottom bottom',
// //       scrub:   0.5,
// //       onUpdate(self) {
// //         if (!imgRef.current) return;

// //         // Read fresh width on every tick — picks up Firestore value
// //         // the moment it arrives, no need to recreate the ScrollTrigger.
// //         const w      = getImgW();
// //         const sX     =  window.innerWidth  + w * 0.1;
// //         const sY     = -(w * 1.3);
// //         const eX     = -(w * 1.1);
// //         const eY     =  window.innerHeight + w * 0.1;

// //         const p       = self.progress;
// //         const visible = p > 0.01 && p < 0.99;

// //         gsap.set(imgRef.current, { opacity: visible ? 1 : 0 });
// //         if (!visible) return;

// //         const eased = easeInOutCubic(p);
// //         gsap.set(imgRef.current, {
// //           width:    w,
// //           x:        sX + (eX - sX) * eased,
// //           y:        sY + (eY - sY) * eased,
// //           rotation: 12 + (-8 - 12) * eased,
// //         });
// //       },
// //     });

// //     return () => {
// //       anim.kill();
// //       if (imgRef.current) gsap.set(imgRef.current, { opacity: 0 });
// //     };

// //   }, [loaded, isMobile, imgUrl]); // imgUrl triggers re-run once <img> mounts

// //   const cols = isMobile ? 1 : 3;

// //   return (
// //     <div
// //       ref={wrapperRef}
// //       id="skills"
// //       style={{
// //         height:   isMobile ? '280vh' : '400vh',
// //         position: 'relative',
// //       }}
// //     >
// //       <section
// //         ref={sectionRef}
// //         data-cursor-text="Scroll&#10;Slowly"
// //         style={{
// //           background:    'var(--black)',
// //           position:      'relative',
// //           overflow:      'hidden',
// //           padding:       isMobile ? '3rem 5vw 2rem' : '5rem 5vw',
// //           height:        '100vh',
// //           display:       'flex',
// //           flexDirection: 'column',
// //           boxSizing:     'border-box',
// //         }}
// //       >
// //         {/* Rendered only once imgUrl is known; opacity=0 — GSAP drives visibility */}
// //         {imgUrl && (
// //           <img
// //             ref={imgRef}
// //             src={imgUrl}
// //             alt=""
// //             aria-hidden="true"
// //             style={{
// //               position:      'absolute',
// //               top:           0,
// //               left:          0,
// //               height:        'auto',
// //               borderRadius:  '10px',
// //               willChange:    'transform',
// //               zIndex:        9999,
// //               pointerEvents: 'none',
// //               opacity:       0,
// //             }}
// //             onError={e => { e.currentTarget.style.display = 'none'; }}
// //           />
// //         )}

// //         {/* Content layer */}
// //         <div style={{
// //           position:      'relative',
// //           zIndex:        20,
// //           flex:          1,
// //           display:       'flex',
// //           flexDirection: 'column',
// //           minHeight:     0,
// //         }}>

// //           <Label n="02" text="Skills" />

// //           <div style={{
// //             display:        'flex',
// //             alignItems:     isMobile ? 'flex-start' : 'baseline',
// //             flexDirection:  isMobile ? 'column' : 'row',
// //             justifyContent: 'space-between',
// //             gap:            isMobile ? '0.4rem' : '1rem',
// //             marginBottom:   isMobile ? '1.5rem' : '2.5rem',
// //           }}>
// //             <div style={{
// //               fontFamily:    'Syne, sans-serif',
// //               fontSize:      isMobile
// //                 ? 'clamp(1.6rem, 8vw, 2.2rem)'
// //                 : 'clamp(2rem, 4vw, 3.2rem)',
// //               fontWeight:    800,
// //               letterSpacing: '-0.05em',
// //               lineHeight:    0.9,
// //               color:         'var(--white)',
// //             }}>
// //               Tech <span style={{ color: 'var(--acid)' }}>Arsenal</span>
// //             </div>
// //             <div style={{
// //               fontFamily:    'Space Mono, monospace',
// //               fontSize:      isMobile ? '0.58rem' : '0.65rem',
// //               color:         '#333',
// //               letterSpacing: '0.18em',
// //               textTransform: 'uppercase',
// //             }}>
// //               {skillGroups.length > 0 ? `${skillGroups.length} categories` : ''}
// //             </div>
// //           </div>

// //           <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '1.5rem' : '2.5rem' }} />

// //           <div style={{
// //             display:             'grid',
// //             gridTemplateColumns: `repeat(${cols}, 1fr)`,
// //             gap:                 0,
// //             flex:                1,
// //             alignContent:        'start',
// //             overflowY:           isMobile ? 'auto' : 'visible',
// //           }}>
// //             {skillGroups.map((grp, gi) => (
// //               <SkillColumn
// //                 key={gi}
// //                 grp={grp}
// //                 index={gi}
// //                 isMobile={isMobile}
// //                 cols={cols}
// //                 isFirst={gi % cols === 0}
// //               />
// //             ))}
// //           </div>

// //         </div>
// //       </section>
// //     </div>
// //   );
// // }

// // function SkillColumn({ grp, index, isMobile, cols, isFirst }) {
// //   const padded = String(index + 1).padStart(2, '0');

// //   return (
// //     <div style={{
// //       borderLeft: isFirst ? 'none' : '1px solid #131313',
// //       padding:    isFirst
// //         ? `0 ${isMobile ? '0.6rem' : '1.5rem'} ${isMobile ? '1.2rem' : '0'} 0`
// //         : `0 ${isMobile ? '0.6rem' : '1.5rem'} ${isMobile ? '1.2rem' : '0'} ${isMobile ? '0.6rem' : '1.2rem'}`,
// //     }}>

// //       <div style={{
// //         fontFamily:    'Space Mono, monospace',
// //         fontSize:      '0.55rem',
// //         color:         '#1c1c1c',
// //         letterSpacing: '0.14em',
// //         textAlign:     'right',
// //         marginBottom:  '0.3rem',
// //       }}>
// //         {padded}
// //       </div>

// //       <div style={{
// //         fontFamily:    'Syne, sans-serif',
// //         fontSize:      isMobile
// //           ? 'clamp(0.75rem, 2.5vw, 1rem)'
// //           : 'clamp(0.95rem, 1.4vw, 1.2rem)',
// //         fontWeight:    800,
// //         letterSpacing: '-0.02em',
// //         color:         grp.color,
// //         textTransform: 'uppercase',
// //         marginBottom:  isMobile ? '0.6rem' : '1rem',
// //         lineHeight:    1,
// //       }}>
// //         {grp.cat}
// //       </div>

// //       <div>
// //         {grp.items.map(([name, pct], si) => (
// //           <div key={si} style={{ borderTop: '1px solid #131313', padding: isMobile ? '0.4rem 0' : '0.55rem 0' }}>
// //             <div style={{
// //               display:        'flex',
// //               alignItems:     'baseline',
// //               justifyContent: 'space-between',
// //               gap:            '0.3rem',
// //               marginBottom:   pct != null ? '0.25rem' : 0,
// //             }}>
// //               <span style={{
// //                 fontFamily:    'Space Mono, monospace',
// //                 fontSize:      isMobile ? '0.56rem' : '0.7rem',
// //                 letterSpacing: '0.05em',
// //                 textTransform: 'uppercase',
// //                 color:         'var(--white)',
// //                 opacity:       0.8,
// //                 overflow:      'hidden',
// //                 textOverflow:  'ellipsis',
// //                 whiteSpace:    'nowrap',
// //                 minWidth:      0,
// //                 flex:          1,
// //               }}>
// //                 {name}
// //               </span>

// //               {pct != null && !isMobile && (
// //                 <span style={{
// //                   fontFamily:    'Space Mono, monospace',
// //                   fontSize:      '0.62rem',
// //                   color:         grp.color,
// //                   opacity:       0.5,
// //                   letterSpacing: '0.06em',
// //                   flexShrink:    0,
// //                 }}>
// //                   {pct}
// //                 </span>
// //               )}
// //             </div>

// //             {pct != null && (
// //               <div style={{ height: '1.5px', background: '#0e0e0e', position: 'relative' }}>
// //                 <div style={{
// //                   position:   'absolute',
// //                   top:        0,
// //                   left:       0,
// //                   height:     '100%',
// //                   width:      `${pct}%`,
// //                   background: grp.color,
// //                 }} />
// //               </div>
// //             )}
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }


// import { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { fetchSkillGroups, fetchSkillsMeta } from './data';
// import { Label } from './utils';

// gsap.registerPlugin(ScrollTrigger);

// function easeInOutCubic(t) {
//   return t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2;
// }

// const DEFAULT_DESKTOP_VW = 22;
// const DEFAULT_MOBILE_VW  = 48;

// export default function Skills({ loaded, isMobile }) {
//   const [skillGroups, setSkillGroups] = useState([]);
//   const [imgUrl,      setImgUrl]      = useState('');

//   // Width values live in refs — NOT state.
//   // The onUpdate closure reads them directly, so changing them
//   // never needs to recreate the ScrollTrigger.
//   const desktopVwRef = useRef(DEFAULT_DESKTOP_VW);
//   const mobileVwRef  = useRef(DEFAULT_MOBILE_VW);

//   const wrapperRef   = useRef(null);
//   const sectionRef   = useRef(null);
//   const imgRef       = useRef(null);

//   // ── Data fetch ───────────────────────────────────────────────────────────────
//   useEffect(() => {
//     fetchSkillGroups().then(setSkillGroups).catch(console.error);

//     fetchSkillsMeta()
//       .then(m => {
//         if (m.floatingImage)              setImgUrl(m.floatingImage);
//         if (m.desktopWidthVw != null)     desktopVwRef.current = Number(m.desktopWidthVw);
//         if (m.mobileWidthVw  != null)     mobileVwRef.current  = Number(m.mobileWidthVw);
//       })
//       .catch(console.error);
//   }, []);

//   // ── GSAP: pin only — created once when loaded ─────────────────────────────
//   // This ScrollTrigger must never be killed/recreated, otherwise the pinned
//   // section loses its layout position mid-scroll.
//   useEffect(() => {
//     if (!loaded) return;

//     const pin = ScrollTrigger.create({
//       trigger:    wrapperRef.current,
//       start:      'top top',
//       end:        'bottom bottom',
//       pin:        sectionRef.current,
//       pinSpacing: false,
//     });

//     return () => pin.kill();
//   }, [loaded]);

//   // ── GSAP: animation — created once when loaded AND img is in the DOM ──────
//   // startX/startY are defined ONCE and shared between gsap.set and onUpdate,
//   // so the image never jumps to a different start point when scrolling begins.
//   useEffect(() => {
//     if (!loaded)         return;
//     if (!imgRef.current) return; // img not mounted yet

//     const getImgW = () => {
//       const vw = (v) => (v / 100) * window.innerWidth;
//       return isMobile ? vw(mobileVwRef.current) : vw(desktopVwRef.current);
//     };

//     const imgW = getImgW();

//     // ── Define start position ONCE ──────────────────────────────────────────
//     // Change these two values to control where the image sits at scroll = 0.
//     // Both gsap.set (initial paint) and onUpdate (scroll tick) use the same
//     // constants, so the image never snaps to a different position on first scroll.
//     const startX = window.innerWidth  * 0.65;   // 65% from left — on screen
//     const startY = window.innerHeight * 0.1;    // 10% from top  — on screen

//     // ── End position — image travels off-screen bottom-left ─────────────────
//     const endX = -(imgW * 1.1);
//     const endY =  window.innerHeight + imgW * 0.1;

//     // Paint the image at the start position immediately (visible from load)
//     gsap.set(imgRef.current, {
//       x:        startX,
//       y:        startY,
//       rotation: 12,
//       opacity:  1,
//       width:    imgW,
//     });

//     const anim = ScrollTrigger.create({
//       trigger: wrapperRef.current,
//       start:   'top top',
//       end:     'bottom bottom',
//       scrub:   0.5,
//       onUpdate(self) {
//         if (!imgRef.current) return;

//         // Re-read width on every tick (picks up Firestore value when it arrives)
//         const w  = getImgW();

//         // End recalculated from fresh width; start stays fixed
//         const eX = -(w * 1.1);
//         const eY =  window.innerHeight + w * 0.1;

//         const p     = self.progress;
//         const eased = easeInOutCubic(p);

//         gsap.set(imgRef.current, {
//           opacity:  p < 0.99 ? 1 : 0,
//           width:    w,
//           x:        startX + (eX - startX) * eased,
//           y:        startY + (eY - startY) * eased,
//           rotation: 12 + (-8 - 12) * eased,
//         });
//       },
//     });

//     return () => {
//       anim.kill();
//       if (imgRef.current) gsap.set(imgRef.current, { opacity: 0 });
//     };

//   }, [loaded, isMobile, imgUrl]); // imgUrl triggers re-run once <img> mounts

//   const cols = isMobile ? 1 : 3;

//   return (
//     <div
//       ref={wrapperRef}
//       id="skills"
//       style={{
//         height:   isMobile ? '280vh' : '400vh',
//         position: 'relative',
//       }}
//     >
//       <section
//         ref={sectionRef}
//         data-cursor-text="Scroll&#10;Slowly"
//         style={{
//           background:    'var(--black)',
//           position:      'relative',
//           overflow:      'hidden',
//           padding:       isMobile ? '3rem 5vw 2rem' : '5rem 5vw',
//           height:        '100vh',
//           display:       'flex',
//           flexDirection: 'column',
//           boxSizing:     'border-box',
//         }}
//       >
//         {/* Rendered only once imgUrl is known; GSAP controls position & opacity */}
//         {imgUrl && (
//           <img
//             ref={imgRef}
//             src={imgUrl}
//             alt=""
//             aria-hidden="true"
//             style={{
//               position:      'absolute',
//               top:           0,
//               left:          0,
//               height:        'auto',
//               borderRadius:  '10px',
//               willChange:    'transform',
//               zIndex:        9999,
//               pointerEvents: 'none',
//               opacity:       0, // GSAP sets to 1 immediately in gsap.set
//             }}
//             onError={e => { e.currentTarget.style.display = 'none'; }}
//           />
//         )}

//         {/* Content layer */}
//         <div style={{
//           position:      'relative',
//           zIndex:        20,
//           flex:          1,
//           display:       'flex',
//           flexDirection: 'column',
//           minHeight:     0,
//         }}>

//           <Label n="02" text="Skills" />

//           <div style={{
//             display:        'flex',
//             alignItems:     isMobile ? 'flex-start' : 'baseline',
//             flexDirection:  isMobile ? 'column' : 'row',
//             justifyContent: 'space-between',
//             gap:            isMobile ? '0.4rem' : '1rem',
//             marginBottom:   isMobile ? '1.5rem' : '2.5rem',
//           }}>
//             <div style={{
//               fontFamily:    'Syne, sans-serif',
//               fontSize:      isMobile
//                 ? 'clamp(1.6rem, 8vw, 2.2rem)'
//                 : 'clamp(2rem, 4vw, 3.2rem)',
//               fontWeight:    800,
//               letterSpacing: '-0.05em',
//               lineHeight:    0.9,
//               color:         'var(--white)',
//             }}>
//               Tech <span style={{ color: 'var(--acid)' }}>Arsenal</span>
//             </div>
//             <div style={{
//               fontFamily:    'Space Mono, monospace',
//               fontSize:      isMobile ? '0.58rem' : '0.65rem',
//               color:         '#333',
//               letterSpacing: '0.18em',
//               textTransform: 'uppercase',
//             }}>
//               {skillGroups.length > 0 ? `${skillGroups.length} categories` : ''}
//             </div>
//           </div>

//           <div style={{ height: '1px', background: '#131313', marginBottom: isMobile ? '1.5rem' : '2.5rem' }} />

//           <div style={{
//             display:             'grid',
//             gridTemplateColumns: `repeat(${cols}, 1fr)`,
//             gap:                 0,
//             flex:                1,
//             alignContent:        'start',
//             overflowY:           isMobile ? 'auto' : 'auto',
//           }}>
//             {skillGroups.map((grp, gi) => (
//               <SkillColumn
//                 key={gi}
//                 grp={grp}
//                 index={gi}
//                 isMobile={isMobile}
//                 cols={cols}
//                 isFirst={gi % cols === 0}
//               />
//             ))}
//           </div>

//         </div>
//       </section>
//     </div>
//   );
// }

// function SkillColumn({ grp, index, isMobile, cols, isFirst }) {
//   const padded = String(index + 1).padStart(2, '0');

//   return (
//     <div style={{
//       borderLeft: isFirst ? 'none' : '1px solid #131313',
//       padding:    isFirst
//         ? `0 ${isMobile ? '0.6rem' : '1.5rem'} ${isMobile ? '1.2rem' : '0'} 0`
//         : `0 ${isMobile ? '0.6rem' : '1.5rem'} ${isMobile ? '1.2rem' : '0'} ${isMobile ? '0.6rem' : '1.2rem'}`,
//     }}>

//       <div style={{
//         fontFamily:    'Space Mono, monospace',
//         fontSize:      '0.55rem',
//         color:         '#1c1c1c',
//         letterSpacing: '0.14em',
//         textAlign:     'right',
//         marginBottom:  '0.3rem',
//       }}>
//         {padded}
//       </div>

//       <div style={{
//         fontFamily:    'Syne, sans-serif',
//         fontSize:      isMobile
//           ? 'clamp(0.75rem, 2.5vw, 1rem)'
//           : 'clamp(0.95rem, 1.4vw, 1.2rem)',
//         fontWeight:    800,
//         letterSpacing: '-0.02em',
//         color:         grp.color,
//         textTransform: 'uppercase',
//         marginBottom:  isMobile ? '0.6rem' : '1rem',
//         lineHeight:    1,
//       }}>
//         {grp.cat}
//       </div>

//       <div>
//         {grp.items.map(([name, pct], si) => (
//           <div key={si} style={{ borderTop: '1px solid #131313', padding: isMobile ? '0.4rem 0' : '0.55rem 0' }}>
//             <div style={{
//               display:        'flex',
//               alignItems:     'baseline',
//               justifyContent: 'space-between',
//               gap:            '0.3rem',
//               marginBottom:   pct != null ? '0.25rem' : 0,
//             }}>
//               <span style={{
//                 fontFamily:    'Space Mono, monospace',
//                 fontSize:      isMobile ? '0.56rem' : '0.7rem',
//                 letterSpacing: '0.05em',
//                 textTransform: 'uppercase',
//                 color:         'var(--white)',
//                 opacity:       0.8,
//                 overflow:      'hidden',
//                 textOverflow:  'ellipsis',
//                 whiteSpace:    'nowrap',
//                 minWidth:      0,
//                 flex:          1,
//               }}>
//                 {name}
//               </span>

//               {pct != null && !isMobile && (
//                 <span style={{
//                   fontFamily:    'Space Mono, monospace',
//                   fontSize:      '0.62rem',
//                   color:         grp.color,
//                   opacity:       0.5,
//                   letterSpacing: '0.06em',
//                   flexShrink:    0,
//                 }}>
//                   {pct}
//                 </span>
//               )}
//             </div>

//             {pct != null && (
//               <div style={{ height: '1.5px', background: '#0e0e0e', position: 'relative' }}>
//                 <div style={{
//                   position:   'absolute',
//                   top:        0,
//                   left:       0,
//                   height:     '100%',
//                   width:      `${pct}%`,
//                   background: grp.color,
//                 }} />
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fetchSkillGroups, fetchSkillsMeta } from './data';
import { Label } from './utils';

gsap.registerPlugin(ScrollTrigger);

function easeInOutCubic(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2;
}

const DEFAULT_DESKTOP_VW = 22;
const DEFAULT_MOBILE_VW  = 48;

export default function Skills({ loaded, isMobile }) {
  const [skillGroups, setSkillGroups] = useState([]);
  const [imgUrl,      setImgUrl]      = useState('');

  const desktopVwRef = useRef(DEFAULT_DESKTOP_VW);
  const mobileVwRef  = useRef(DEFAULT_MOBILE_VW);

  const wrapperRef   = useRef(null);
  const sectionRef   = useRef(null);
  const imgRef       = useRef(null);
  const gridRef      = useRef(null); // ← ref for the scrollable grid

  // ── Data fetch ───────────────────────────────────────────────
  useEffect(() => {
    fetchSkillGroups().then(setSkillGroups).catch(console.error);

    fetchSkillsMeta()
      .then(m => {
        if (m.floatingImage)          setImgUrl(m.floatingImage);
        if (m.desktopWidthVw != null) desktopVwRef.current = Number(m.desktopWidthVw);
        if (m.mobileWidthVw  != null) mobileVwRef.current  = Number(m.mobileWidthVw);
      })
      .catch(console.error);
  }, []);

  // ── GSAP: pin ─────────────────────────────────────────────────
  useEffect(() => {
    if (!loaded) return;

    const pin = ScrollTrigger.create({
      trigger:    wrapperRef.current,
      start:      'top top',
      end:        'bottom bottom',
      pin:        sectionRef.current,
      pinSpacing: false,
    });

    return () => pin.kill();
  }, [loaded]);

  // ── GSAP: scroll grid content via page scroll progress ────────
  useEffect(() => {
    if (!loaded)          return;
    if (!gridRef.current) return;

    // Re-create when skillGroups changes so maxScroll is recalculated
    const ctx = gsap.context(() => {
      const anim = ScrollTrigger.create({
        trigger: wrapperRef.current,
        start:   'top top',
        end:     'bottom bottom',
        scrub:   0.6,
        onUpdate(self) {
          if (!gridRef.current) return;

          const el        = gridRef.current;
          const maxScroll = el.scrollHeight - el.clientHeight;

          if (maxScroll <= 0) return; // all content fits, nothing to scroll

          // Use only the second half of scroll progress for grid scrolling
          // so the first half is "reading" row 1 and second half reveals rows below
          const p         = Math.max(0, (self.progress - 0.3) / 0.7);
          const eased     = easeInOutCubic(Math.min(p, 1));
          el.scrollTop    = eased * maxScroll;
        },
      });

      return () => anim.kill();
    });

    return () => ctx.revert();
  }, [loaded, skillGroups]); // re-run when groups load so scrollHeight is accurate

  // ── GSAP: floating image ──────────────────────────────────────
  useEffect(() => {
    if (!loaded)         return;
    if (!imgRef.current) return;

    const getImgW = () => {
      const vw = (v) => (v / 100) * window.innerWidth;
      return isMobile ? vw(mobileVwRef.current) : vw(desktopVwRef.current);
    };

    const imgW   = getImgW();
    const startX = window.innerWidth  * 0.65;
    const startY = window.innerHeight * 0.1;

    gsap.set(imgRef.current, {
      x: startX, y: startY, rotation: 12, opacity: 1, width: imgW,
    });

    const anim = ScrollTrigger.create({
      trigger: wrapperRef.current,
      start:   'top top',
      end:     'bottom bottom',
      scrub:   0.5,
      onUpdate(self) {
        if (!imgRef.current) return;

        const w     = getImgW();
        const eX    = -(w * 1.1);
        const eY    =  window.innerHeight + w * 0.1;
        const p     = self.progress;
        const eased = easeInOutCubic(p);

        gsap.set(imgRef.current, {
          opacity:  p < 0.99 ? 1 : 0,
          width:    w,
          x:        startX + (eX - startX) * eased,
          y:        startY + (eY - startY) * eased,
          rotation: 12 + (-8 - 12) * eased,
        });
      },
    });

    return () => {
      anim.kill();
      if (imgRef.current) gsap.set(imgRef.current, { opacity: 0 });
    };
  }, [loaded, isMobile, imgUrl]);

  const cols = isMobile ? 1 : 3;

  const rows = [];
  for (let i = 0; i < skillGroups.length; i += cols) {
    rows.push(skillGroups.slice(i, i + cols));
  }

  return (
    <div
      ref={wrapperRef}
      id="skills"
      style={{ height: isMobile ? '280vh' : '400vh', position: 'relative' }}
    >
      {/* Hide the scrollbar visually — scroll is driven by GSAP */}
      <style>{`
        .skills-scroll::-webkit-scrollbar { display: none; }
        .skills-scroll { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <section
        ref={sectionRef}
        data-cursor-text="Scroll&#10;Slowly"
        style={{
          background:    'var(--black)',
          position:      'relative',
          overflow:      'hidden',
          padding:       isMobile ? '3rem 5vw 2rem' : '5rem 5vw',
          height:        '100vh',
          display:       'flex',
          flexDirection: 'column',
          boxSizing:     'border-box',
        }}
      >
        {/* Floating image */}
        {imgUrl && (
          <img
            ref={imgRef}
            src={imgUrl}
            alt=""
            aria-hidden="true"
            style={{
              position:      'absolute',
              top:           0,
              left:          0,
              height:        'auto',
              borderRadius:  '10px',
              willChange:    'transform',
              zIndex:        9999,
              pointerEvents: 'none',
              opacity:       0,
            }}
            onError={e => { e.currentTarget.style.display = 'none'; }}
          />
        )}

        {/* ── Static header ── */}
        <div style={{ flexShrink: 0, position: 'relative', zIndex: 20 }}>
          <Label n="02" text="Skills" />

          <div style={{
            display:        'flex',
            alignItems:     isMobile ? 'flex-start' : 'baseline',
            flexDirection:  isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            gap:            isMobile ? '0.4rem' : '1rem',
            marginBottom:   isMobile ? '1.5rem' : '2.5rem',
          }}>
            <div style={{
              fontFamily:    'Syne, sans-serif',
              fontSize:      isMobile
                ? 'clamp(1.6rem, 8vw, 2.2rem)'
                : 'clamp(2rem, 4vw, 3.2rem)',
              fontWeight:    800,
              letterSpacing: '-0.05em',
              lineHeight:    0.9,
              color:         'var(--white)',
            }}>
              Tech <span style={{ color: 'var(--acid)' }}>Arsenal</span>
            </div>
            <div style={{
              fontFamily:    'Space Mono, monospace',
              fontSize:      isMobile ? '0.58rem' : '0.65rem',
              color:         '#333',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
            }}>
              {skillGroups.length > 0 ? `${skillGroups.length} categories` : ''}
            </div>
          </div>

          <div style={{
            height:       '1px',
            background:   '#131313',
            marginBottom: isMobile ? '1.5rem' : '2.5rem',
          }} />
        </div>

        {/* ── Grid — overflow hidden, GSAP drives scrollTop ── */}
        <div
          ref={gridRef}
          className="skills-scroll"
          style={{
            flex:      1,
            minHeight: 0,
            overflowY: 'scroll', // must be scroll (not auto) for scrollTop to work
            overflowX: 'hidden',
            position:  'relative',
            zIndex:    20,
            // pointer-events off so user's wheel goes to the page, not this div
            pointerEvents: 'none',
          }}
        >
          {rows.map((row, ri) => (
            <div
              key={ri}
              style={{
                display:      'flex',
                flexDirection: 'row',
                borderTop:    ri === 0 ? 'none' : '1px solid #131313',
                paddingTop:   ri === 0 ? 0 : isMobile ? '1.5rem' : '2rem',
                marginBottom: isMobile ? '1.5rem' : '2rem',
              }}
            >
              {row.map((grp, gi) => {
                const globalIndex = ri * cols + gi;
                return (
                  <SkillColumn
                    key={globalIndex}
                    grp={grp}
                    index={globalIndex}
                    isMobile={isMobile}
                    cols={cols}
                    isFirst={gi === 0}
                  />
                );
              })}

              {/* Empty cells to keep column borders on short last row */}
              {row.length < cols && !isMobile &&
                Array.from({ length: cols - row.length }).map((_, ei) => (
                  <div
                    key={`empty-${ei}`}
                    style={{
                      flex:       1,
                      borderLeft: '1px solid #131313',
                      padding:    '0 1.5rem 0 1.2rem',
                    }}
                  />
                ))
              }
            </div>
          ))}
        </div>

      </section>
    </div>
  );
}

function SkillColumn({ grp, index, isMobile, cols, isFirst }) {
  const padded = String(index + 1).padStart(2, '0');

  return (
    <div style={{
      flex:       1,
      borderLeft: isFirst ? 'none' : '1px solid #131313',
      padding:    isFirst
        ? `0 ${isMobile ? '0.6rem' : '1.5rem'} 0 0`
        : `0 ${isMobile ? '0.6rem' : '1.5rem'} 0 ${isMobile ? '0.6rem' : '1.2rem'}`,
      minWidth:   0,
    }}>

      <div style={{
        fontFamily:    'Space Mono, monospace',
        fontSize:      '0.55rem',
        color:         '#1c1c1c',
        letterSpacing: '0.14em',
        textAlign:     'right',
        marginBottom:  '0.3rem',
      }}>
        {padded}
      </div>

      <div style={{
        fontFamily:    'Syne, sans-serif',
        fontSize:      isMobile
          ? 'clamp(0.75rem, 2.5vw, 1rem)'
          : 'clamp(0.95rem, 1.4vw, 1.2rem)',
        fontWeight:    800,
        letterSpacing: '-0.02em',
        color:         grp.color,
        textTransform: 'uppercase',
        marginBottom:  isMobile ? '0.6rem' : '1rem',
        lineHeight:    1,
      }}>
        {grp.cat}
      </div>

      <div>
        {grp.items.map(([name, pct], si) => (
          <div
            key={si}
            style={{
              borderTop: '1px solid #131313',
              padding:   isMobile ? '0.4rem 0' : '0.55rem 0',
            }}
          >
            <div style={{
              display:        'flex',
              alignItems:     'baseline',
              justifyContent: 'space-between',
              gap:            '0.3rem',
              marginBottom:   pct != null ? '0.25rem' : 0,
            }}>
              <span style={{
                fontFamily:    'Space Mono, monospace',
                fontSize:      isMobile ? '0.56rem' : '0.7rem',
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                color:         'var(--white)',
                opacity:       0.8,
                overflow:      'hidden',
                textOverflow:  'ellipsis',
                whiteSpace:    'nowrap',
                minWidth:      0,
                flex:          1,
              }}>
                {name}
              </span>

              {pct != null && !isMobile && (
                <span style={{
                  fontFamily:    'Space Mono, monospace',
                  fontSize:      '0.62rem',
                  color:         grp.color,
                  opacity:       0.5,
                  letterSpacing: '0.06em',
                  flexShrink:    0,
                }}>
                  {pct}
                </span>
              )}
            </div>

            {pct != null && (
              <div style={{ height: '1.5px', background: '#0e0e0e', position: 'relative' }}>
                <div style={{
                  position:   'absolute',
                  top:        0,
                  left:       0,
                  height:     '100%',
                  width:      `${pct}%`,
                  background: grp.color,
                }} />
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}